import styled from 'styled-components'

import { mediaIpad, mediaIpadmini, mediaMobile } from './desktop'

export const Footercomponents = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`

export const FooterIconcomponents = styled.div`
    display: flex; 
    justify-content: center;
    width: 30%;
  ${mediaMobile.Mobile`
    display: none;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const FooterContestcomponents = styled.div`
    display: flex;
    justify-content: flex-start; 
    flex-direction: column;
    text-align: left;
    width: 40%;
  ${mediaMobile.Mobile`
    width: 100%;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`

export const FooterMapcomponents = styled.div`
    display: flex; 
    justify-content: center;
    width: 30%;
  ${mediaMobile.Mobile`
    display: none;
  `}
  ${mediaIpadmini.Ipadmini`
    
  `}
  ${mediaIpad.Ipad`
    
  `}
`



// WEBPACK FOOTER //
// ./src/components/styled-components/footerStyled.js